export default __webpack_public_path__ + "static/11-52f1def451fb2a9ebaebc09e7c599d4a.jpg";